export const DEFAULT_LOCALE = "en";
// Variantes régionales significatives conservées telles quelles lors de la
// normalisation (le reste est réduit au sous-tag principal : "fr-FR" → "fr")
const PRESERVED_REGIONAL_LOCALES = new Set(["pt-br", "pt-pt", "zh-cn", "zh-tw"]);
const LOCALE_CODE_RE = /^[a-z]{2,3}(-[a-z]{2,4})?$/;
/**
 * Normalise un code langue brut en code canonique lowercase.
 * "fr-FR" → "fr", "nl_NL" → "nl", "pt-BR" → "pt-br" (variante conservée).
 * Retourne null si l'entrée n'est pas un code de locale plausible.
 */
export function normalizeLocaleCode(raw) {
    const lowered = raw.trim().toLowerCase().replace(/_/g, "-");
    if (lowered.length === 0)
        return null;
    const parts = lowered.split("-");
    const primary = parts[0] ?? "";
    const withRegion = parts.length > 1 ? `${primary}-${parts[1]}` : primary;
    const candidate = PRESERVED_REGIONAL_LOCALES.has(withRegion) ? withRegion : primary;
    return LOCALE_CODE_RE.test(candidate) ? candidate : null;
}
/**
 * Libellé humain d'une locale via Intl.DisplayNames, dans sa propre langue
 * par défaut ("nl" → "Nederlands"). Retombe sur le code en cas d'échec.
 */
export function getLocaleDisplayName(locale, displayIn) {
    try {
        const name = new Intl.DisplayNames([displayIn ?? locale], { type: "language" }).of(locale);
        if (!name || name === locale)
            return capitalize(locale);
        return capitalize(name);
    }
    catch {
        return capitalize(locale);
    }
}
function capitalize(value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
}
/**
 * Détermine la langue initiale selon la priorité :
 * 1. préférence enregistrée côté compte utilisateur
 * 2. choix local explicite précédent (localStorage)
 * 3. navigator.languages / navigator.language
 * 4. anglais (défaut)
 */
export function resolveInitialLocale(accountPreference, storedChoice, navigatorLanguages) {
    if (accountPreference) {
        const normalized = normalizeLocaleCode(accountPreference);
        if (normalized)
            return { locale: normalized, detectedFrom: "account" };
    }
    if (storedChoice) {
        const normalized = normalizeLocaleCode(storedChoice);
        if (normalized)
            return { locale: normalized, detectedFrom: "storage" };
    }
    for (const lang of navigatorLanguages) {
        const normalized = normalizeLocaleCode(lang);
        if (normalized)
            return { locale: normalized, detectedFrom: "navigator" };
    }
    return { locale: DEFAULT_LOCALE, detectedFrom: "default" };
}
/** Première locale navigateur normalisée, ou null. */
export function detectBrowserLocale(navigatorLanguages) {
    for (const lang of navigatorLanguages) {
        const normalized = normalizeLocaleCode(lang);
        if (normalized)
            return normalized;
    }
    return null;
}
//# sourceMappingURL=locale.js.map